module.exports = __webpack_public_path__ + "media/Melody of Eternity.c9256325.mp3";